import { render, staticRenderFns } from "./echartscom.vue?vue&type=template&id=06cdaed0&scoped=true&"
import script from "./echartscom.vue?vue&type=script&lang=js&"
export * from "./echartscom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cdaed0",
  null
  
)

export default component.exports